import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../utils/axiosInstance';
import { toast } from 'react-toastify';


const Navbar = ({ employeeId }) => {
    ////console.log("the dashboard ID is", employeeId)

    const { t } = useTranslation();

    const [employeeName, setEmployeeName] = useState('');
    const [employeeSapId, setEmployeeSapId] = useState();
    const [employeeImage, setEmployeeImage] = useState(null);

    useEffect(() => {
        if (employeeId) {  // Only fetch data if employeeId is available
            const fetchEmployeeData = async () => {
                try {
                    const response = await axiosInstance.get(`/user/employeeDetails/${employeeId}`);
                    const data = response.data;
                    setEmployeeName(data.employeeName);
                    setEmployeeImage(data.employeeImage);
                    setEmployeeSapId(data.empSapId);
                } catch (error) {
                    // Check if error response is available
                    if (!error.response) {
                        // Network error or no response
                        toast.error("Looks like you are offline. Please check your internet connectivity.");
                    } else {
                        console.error('Error fetching employee data:', error);
                    }
                }
            };

            fetchEmployeeData();
        }
    }, [employeeId]);

    const quotes = [
        {
            quote: "Don’t worry about failures, worry about the chances you miss when you don't even try.",
            writer: "- John Kennedy"
        },
        {
            quote: "The only way to do great work is to love what you do.",
            writer: "- Steve Jobs"
        },
        {
            quote: "Success is not final, failure is not fatal: It is the courage to continue that counts.",
            writer: "- Winston Churchill"
        },
        // Add more quotes as needed
    ];

    const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentQuoteIndex(prevIndex => (prevIndex + 1) % quotes.length);
        }, 5000); // Change quote every 5 seconds

        return () => clearInterval(interval);
    }, [quotes.length]);

    // Function to extract first name from full name
    const getFirstName = (fullName) => {
        const names = fullName.split(' ');
        return names[0];
    };

    return (
        <div className='navbar'>
            <div className='navbar-greeting-header'>
                {t("topnav_greetings")} {employeeName ? getFirstName(employeeName) : '...'}
                <span>{t("topnav_welcome")}</span>
            </div>
            {/* <div className='navbar-quote-body'>
                <div className='navbar-quote'>
                    {quotes[currentQuoteIndex].quote}
                </div>
                <div className='navbar-quote-writer'>
                    {quotes[currentQuoteIndex].writer}
                </div>
            </div> */}
            <div className='navbar-profile'>
                <div className='navbar-profile-info'>
                    <span>{employeeName || 'Employee Name'}</span>
                    <div>{employeeSapId || 'Employee Id'}</div>
                </div>
                {/* <div className='navbar-profile-image'>
                    {employeeImage ? (
                        <img src={employeeImage} alt="Employee" className="employee-image" />
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                            <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1" />
                        </svg>
                    )} 
                </div> */}
            </div>
        </div>
    );
};

export default Navbar;
